

import React from 'react';
import StatementsList from './StatementsList';

const Statements: React.FC = () => {
  return (
    <>
      <h1>Statements</h1>
      <StatementsList />
    </>
  );
};

export default Statements;